<div class="container">
  <app-shell style="width: 100%; height: 100%">
    <div class="stack">
      <div id="question">
        <h1>{{ this.questionText }}</h1>
        <app-tool-tip
          [pageContent]="this.tooltipContent"
          style="align-self: center"
        ></app-tool-tip>
      </div>

      <div id="question-answer">
        <ng-container [formGroup]="form">
          <div class="files">
            <app-file-dropzone-with-list
              formControlName="filesData"
              [uploadSaveUrl]="this.uploadSaveUrl"
              removeSaveUrl=""
              [documentType]="this.documentType"
              [parentForm]="form"
              [multipleFile]="true"
              [showFilesInDropzone]="true"
            ></app-file-dropzone-with-list>
          </div>
          <div
            class="parent-invalid-feedback"
            *ngIf="
              this.form.get('filesData')?.invalid &&
              (this.form.get('filesData')?.dirty ||
                this.form.get('filesData')?.touched)
            "
          >
            <div class="invalid-feedback">
              <kendo-formerror
                *ngIf="this.form.get('filesData')?.errors?.['required']"
              >
                file is required
              </kendo-formerror>
            </div>
          </div>
          <div class="grid-width">
            <app-document-upload-table
              [documentBehaviorSubject]="this.documentBehaviorSubject"
              [onDelete]="this.onDelete.bind(this)"
              [onDownload]="this.onDownload.bind(this)"
            ></app-document-upload-table>
          </div>
          <div class="button-wrapper">
            <app-stateful-primary-button
              type="submit"
              text="Next"
              [pageUrl]="this.nextState['pageUrl']"
              [stateId]="this.nextState['id']"
              [clickEvent]="this.submit.bind(this)"
            ></app-stateful-primary-button>
          </div>
        </ng-container>
      </div>

      <div id="bottom-nav">
        <div id="back">
          <app-stateful-secondary-button
            type="submit"
            [text]="'Back'"
            [pageUrl]="this.backState['pageUrl']"
            [stateId]="this.backState['id']"
          ></app-stateful-secondary-button>
        </div>
        <div id="skip">
          <app-stateful-secondary-button
            type="submit"
            [text]="'Skip'"
            [pageUrl]="this.skipState['pageUrl']"
            [stateId]="this.skipState['id']"
            [clickEvent]="this.skip.bind(this)"
          ></app-stateful-secondary-button>
        </div>
      </div>
    </div>
  </app-shell>
</div>
